/**
 * ANIMATION D'ENTRÉE — header et haut de page
 *
 * Les états initiaux sont posés en CSS sous html.anim (voir hdp.scss et le script
 * inline de header.php), pour qu'aucun flash du rendu final n'apparaisse avant
 * l'exécution du JS. La classe est retirée en fin de séquence.
 *
 * Au scroll, les visuels de la bande quittent le haut de l'écran, en stagger
 * depuis la gauche.
 */
jQuery(document).ready(function ($) {

    // départs dans la séquence, en secondes : le header ferme la marche
    const DEP_FOND = 0
    const DEP_BANDE = .55
    const DEP_TEXTE = 1.25
    const DEP_HEADER = 1.85

    const SORTIE_HAUTEUR = 1.1          // multiple de la hauteur d'écran parcouru par les visuels
    const SORTIE_ZOOM = 1.45            // zoom de la photo dans son cadre pendant la remontée
    const SORTIE_STAGGER = .08          // décalage entre visuels pendant la remontée
    const SORTIE_EASE = "power2.inOut"  // courbe de la remontée : départ et arrivée adoucis
    const SORTIE_LISSAGE = 1            // secondes de rattrapage du scroll, c'est ce qui donne le glissé

    const html = document.documentElement
    const bloc = document.querySelector(".bloc_hdp")

    const entete = gsap.utils.toArray("#header .infobar, #header > .inner > *")
    const visuels = bloc ? gsap.utils.toArray(bloc.querySelectorAll(".bande_visuels .visuel")) : []
    const textes = bloc ? gsap.utils.toArray(bloc.querySelectorAll(".inner .texte > *, .bottom > *")) : []

    /**
     * En carousel mobile (voir 14_bande_visuels.js), la bande contient aussi des
     * clones et la piste glisse en continu : au moment de la sortie au scroll,
     * l'ordre du DOM n'est plus l'ordre à l'écran et un stagger y dessinerait une
     * vague incohérente. Sous ce régime, les visuels remontent d'un seul bloc.
     */
    const enCarousel = bloc ? bloc.querySelector(".bande_visuels.est_carousel") !== null : false

    // animations réduites : on lève les états initiaux sans rien jouer
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        html.classList.remove("anim")
        return
    }

    /**
     * SÉQUENCE D'ENTRÉE
     *
     * force3D: true est indispensable. Par défaut GSAP promeut l'élément en
     * translate3d pendant le tween puis le repasse en 2D à la fin : ce changement
     * de couche force une rastérisation et produit un saut visible sur les images,
     * exactement au moment où l'animation se termine.
     */
    const tl = gsap.timeline({
        defaults: { ease: "power2.out", force3D: true },
        onComplete: function () {
            html.classList.remove("anim")
        }
    })

    // 1 — le fond. La bande et le texte étant masqués à cet instant, monter
    // l'opacité du bloc entier ne révèle que l'image de fond et son voile.
    if (bloc) {
        tl.fromTo(bloc,
            { opacity: 0, scale: 1.06 },
            { opacity: 1, scale: 1, duration: 1.4 },
            DEP_FOND)
    }

    // 2 — la bande : ouverture du clip depuis le centre vers les quatre bords
    if (visuels.length) {
        tl.fromTo(visuels,
            { clipPath: "inset(50% 50% 50% 50%)", scale: 1.06 },
            {
                clipPath: "inset(0% 0% 0% 0%)",
                scale: 1,
                duration: 1,
                stagger: .09,
                ease: "power3.out"
            },
            DEP_BANDE)
    }

    // 3 — titre, accroche, bouton
    if (textes.length) {
        tl.fromTo(textes,
            { opacity: 0, y: 24 },
            { opacity: 1, y: 0, duration: .9, stagger: .12 },
            DEP_TEXTE)
    }

    // 4 — le header en dernier, une fois le haut de page installé
    if (entete.length) {
        tl.fromTo(entete,
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: .8, stagger: .12 },
            DEP_HEADER)
    }

    /**
     * AU SCROLL — les visuels remontent et quittent le haut de l'écran, en zoomant
     * dans leur cadre.
     *
     * Le cadre reçoit y, l'image reçoit scale : la séquence d'entrée animant
     * clipPath et scale sur le cadre, aucune des deux n'écrit la propriété de l'autre.
     *
     * start et end sont donnés en positions de scroll absolues plutôt que mesurés
     * sur le bloc : le scale de la séquence d'entrée agrandit temporairement le
     * bloc de 6%, ce qui faussait la mesure sans qu'on puisse la corriger après coup.
     * Le hdp étant toujours en tête de page, 0 → hauteur d'écran est exact.
     */
    if (bloc && visuels.length) {
        const images = gsap.utils.toArray(bloc.querySelectorAll(".bande_visuels .visuel img"))

        const sortie = gsap.timeline({
            defaults: { ease: SORTIE_EASE, force3D: true, duration: 1, stagger: enCarousel ? 0 : SORTIE_STAGGER },
            scrollTrigger: {
                trigger: bloc,
                start: 0,
                end: function () {
                    return window.innerHeight
                },
                scrub: SORTIE_LISSAGE,
                invalidateOnRefresh: true
            }
        })

        // remontée du cadre
        sortie.to(visuels, {
            y: function () {
                return -window.innerHeight * SORTIE_HAUTEUR
            }
        }, 0)

        // zoom de la photo dans le cadre, clippé par son overflow
        if (images.length)
            sortie.to(images, { scale: SORTIE_ZOOM }, 0)
    }

})
